// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"2d9d3fcc","454":"6faec893","906":"e26597f9"}[chunkId] + ".chunk.css";
};